import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NetworkService } from '../../../core/services/network/network.service';

@Component({
    selector: 'app-offline-banner',
    imports: [NgIf, AsyncPipe, TranslateModule],
    templateUrl: './offline-banner.component.html',
    styleUrls: ['./offline-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfflineBannerComponent {
  protected readonly online$ = inject(NetworkService).online$;
}
